// Keycloak-OIDC (Realm iso, public Client navigator-app, PKCE/S256).
// Ein Konto fuer Kauf (Access) und Nutzung (Navigator).
import Keycloak from "keycloak-js"
import { CONFIG } from "./config"

export const keycloak = new Keycloak({
  url: CONFIG.keycloakUrl,
  realm: CONFIG.keycloakRealm,
  clientId: CONFIG.keycloakClient,
})

let initPromise: Promise<boolean> | null = null

/** Initialisiert Keycloak genau einmal (check-sso, ohne harten Login-Zwang). */
export function initAuth(): Promise<boolean> {
  if (initPromise) return initPromise
  initPromise = keycloak
    .init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      checkLoginIframe: false,
      silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
    })
    .then((authed) => {
      keycloak.onTokenExpired = () => {
        keycloak.updateToken(30).catch(() => {
          // Refresh fehlgeschlagen -> stiller Zustand, UI bietet erneuten Login an.
        })
      }
      return authed
    })
    .catch(() => false)
  return initPromise
}

export function login(): void {
  keycloak.login({ redirectUri: window.location.href })
}

export function logout(): void {
  keycloak.logout({ redirectUri: window.location.origin })
}

/** Gueltiges Access-Token (nach best-effort Refresh) fuer den Authorization-Header. */
export async function freshToken(): Promise<string | undefined> {
  try {
    await keycloak.updateToken(30)
  } catch {
    /* Token evtl. abgelaufen; Aufrufer behandelt 401 */
  }
  return keycloak.token
}

export function displayName(): string {
  const p = keycloak.tokenParsed as { name?: string; email?: string } | undefined
  return p?.name || p?.email || "Konto"
}
